module.exports = __webpack_public_path__ + "static/webinar-9ea993891654c5b0e4f20baad6f8d315.gif";